var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-items-center d-flex flex-column justify-content-center text-center nodata-sub-national"},[_c('h5',[_vm._v("No Sub-National Level Data")]),_c('p',[_vm._v(" There is no sub-national data available for the indicator, data source and period you have selected. Try selecting another data source or period. ")])])
}]

export { render, staticRenderFns }